import React from "react";
import { Text } from "react-native";
import Svg, { Path } from "react-native-svg";

import { ADMIN_TOKENS } from "../../../../../styles/adminTokens";
import { getMessageStatusBadgeStyle } from "../utils/formatters";
import { styles } from "../HomeConversations.styles";

type MessageStatusBadgeProps = {
  status?: string | null;
};

const toStatusLabel = (status?: string | null): string => {
  const normalizedStatus = (status || "").trim().toLowerCase();
  if (!normalizedStatus) {
    return "Unknown";
  }
  return normalizedStatus.replace(/[_-]+/g, " ");
};

const MessageStatusBadge: React.FC<MessageStatusBadgeProps> = ({ status }) => {
  const normalizedStatus = (status || "").trim().toLowerCase();
  const badgeStyle = getMessageStatusBadgeStyle(status);
  if (normalizedStatus === "delivered") {
    return (
      <Svg
        width={ADMIN_TOKENS.fontSize.sm}
        height={ADMIN_TOKENS.fontSize.sm}
        viewBox="0 -960 960 960"
        fill={badgeStyle.textColor}
        accessibilityLabel="Delivered"
      >
        <Path d="M268-240 42-466l57-56 170 170 56 56-57 56Zm226 0L268-466l56-57 170 170 368-368 56 57-424 424Zm0-226-57-56 198-198 57 56-198 198Z" />
      </Svg>
    );
  }

  return (
    <Text
      style={[styles.statusBadgePlainText, { color: badgeStyle.textColor }]}
    >
      {toStatusLabel(status)}
    </Text>
  );
};

export default MessageStatusBadge;
